var _rect, _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaviconIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pzdysoprua)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.219,
    width: 40,
    height: 40,
    rx: 2,
    fill: "#6238F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9.219c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zm8.9 10h-4c-.2-2.8-1.1-5.4-2.7-7.7 3.6.9 6.3 4 6.7 7.7zm-5.9 2h-5.9c.2 2.7 1.2 5.3 3 7.4 1.6-2.1 2.6-4.7 2.9-7.4zm-5.9-2c.3-2.7 1.3-5.3 2.9-7.4 1.7 2.2 2.7 4.8 2.9 7.4h-5.8zm-2 0c.2-2.8 1.1-5.4 2.6-7.7-3.5.9-6.2 4-6.6 7.7h4zm-4 2h4c.2 2.8 1.1 5.4 2.7 7.7-3.6-.9-6.3-4-6.7-7.7zm13.9 0c-.3 2.8-1.2 5.4-2.7 7.7 3.5-.9 6.2-4 6.7-7.7h-4z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d07i0kdtub",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 22,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9.219c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zm8.9 10h-4c-.2-2.8-1.1-5.4-2.7-7.7 3.6.9 6.3 4 6.7 7.7zm-5.9 2h-5.9c.2 2.7 1.2 5.3 3 7.4 1.6-2.1 2.6-4.7 2.9-7.4zm-5.9-2c.3-2.7 1.3-5.3 2.9-7.4 1.7 2.2 2.7 4.8 2.9 7.4h-5.8zm-2 0c.2-2.8 1.1-5.4 2.6-7.7-3.5.9-6.2 4-6.6 7.7h4zm-4 2h4c.2 2.8 1.1 5.4 2.7 7.7-3.6-.9-6.3-4-6.7-7.7zm13.9 0c-.3 2.8-1.2 5.4-2.7 7.7 3.5-.9 6.2-4 6.7-7.7h-4z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d07i0kdtub)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8.219h24v24H8z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pzdysoprua"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .219)",
    d: "M0 0h40v40H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviconIcon);
export default __webpack_public_path__ + "static/media/favicon-icon.39b198971081148b43f1cfceac2631d0.svg";
export { ForwardRef as ReactComponent };